import { Box } from '@mui/material';
import LineGraph from '../../Graphs/LineGraph';
import { useAppSelector } from '../../../redux/ReduxHooks';
import { Graph } from '../dashboardTypes';
import type { ChartSeriesLabelOptions } from '../../Graphs/chartSeriesLabel';
import { GraphNoDataMessage } from '../../Graphs/GraphNoDataMessage';

interface LineGraphWidgetProps {
  graph: Graph | undefined;
  chartSeriesLabelOptions?: ChartSeriesLabelOptions;
}

const LineGraphWidget = ({ graph, chartSeriesLabelOptions }: LineGraphWidgetProps) => {
  const runDate = useAppSelector((state) => state.application.runDate);

  return (
    <Box className="widget-body" flex="1" overflow="hidden" justifyContent="center" alignItems="center" display="flex">
      {graph ? (
        <LineGraph graph={graph} chartSeriesLabelOptions={chartSeriesLabelOptions} key={`${graph?.key}_${runDate}`} />
      ) : (
        <GraphNoDataMessage />
      )}
    </Box>
  );
};

export default LineGraphWidget;
